export const Leftmenu = (resolve) => {
  require.ensure(['@/components/layout/Leftmenu'], () => {
    resolve(require('@/components/layout/Leftmenu'));
  });
};
export const Topbar = (resolve) => {
  require.ensure(['@/components/layout/Topbar'], () => {
    resolve(require('@/components/layout/Topbar'));
  });
};
export const Login = (resolve) => {
  require.ensure(['@/components/login/Index'], () => {
    resolve(require('@/components/login/Index'));
  });
};

// 首页
export const Home = (resolve) => {
  require.ensure(['@/components/home/Index'], () => {
    resolve(require('@/components/home/Index'));
  });
};
export const Homemain = (resolve) => {
  require.ensure(['@/components/home/Main'], () => {
    resolve(require('@/components/home/Main'));
  });
};
export const Homemessage = (resolve) => {
  require.ensure(['@/components/home/Message'], () => {
    resolve(require('@/components/home/Message'));
  });
};
export const Homesynchronousxchange = (resolve) => {
  require.ensure(['@/components/home/Synchronousxchange'], () => {
    resolve(require('@/components/home/Synchronousxchange'));
  });
};
export const Homeaffiche = (resolve) => {
  require.ensure(['@/components/home/Affiche'], () => {
    resolve(require('@/components/home/Affiche'));
  });
};
export const Homevfpmenu = (resolve) => {
  require.ensure(['@/components/home/Left'], () => {
    resolve(require('@/components/home/Left'));
  });
};
export const Homememo = (resolve) => {
  require.ensure(['@/components/home/Memo'], () => {
    resolve(require('@/components/home/Memo'));
  });
};
export const Homecontact = (resolve) => {
  require.ensure(['@/components/home/Contact'], () => {
    resolve(require('@/components/home/Contact'));
  });
};

export const Statisticsinvoicedaohang = (resolve) => {
  require.ensure(['@/components/statistics/Invoicedaohang'], () => {
    resolve(require('@/components/statistics/Invoicedaohang'));
  });
};

export const Statisticsinvoicemingxi = (resolve) => {
  require.ensure(['@/components/statistics/Invoicemingxi'], () => {
    resolve(require('@/components/statistics/Invoicemingxi'));
  });
};
export const Statisticsinvoicemingxisell = (resolve) => {
  require.ensure(['@/components/statistics/Invoicemingxisell'], () => {
    resolve(require('@/components/statistics/Invoicemingxisell'));
  });
};


// CRM部分
export const Crm = (resolve) => {
  require.ensure(['@/components/crm/Index'], () => {
    resolve(require('@/components/crm/Index'));
  });
};
export const Crmmain = (resolve) => {
  require.ensure(['@/components/crm/Main'], () => {
    resolve(require('@/components/crm/Main'));
  });
};
export const Crmvfpmenu = (resolve) => {
  require.ensure(['@/components/crm/Left'], () => {
    resolve(require('@/components/crm/Left'));
  });
};
export const Crmchance = (resolve) => {
  require.ensure(['@/components/crm/Chance'], () => {
    resolve(require('@/components/crm/Chance'));
  });
};
export const Crmchancestat = (resolve) => {
  require.ensure(['@/components/crm/Chancestat'], () => {
    resolve(require('@/components/crm/Chancestat'));
  });
};
export const Crmhope = (resolve) => {
  require.ensure(['@/components/crm/Hope'], () => {
    resolve(require('@/components/crm/Hope'));
  });
};
export const Crmhopecolleague = (resolve) => {
  require.ensure(['@/components/crm' +
  '/Hopecolleague'], () => {
    resolve(require('@/components/crm/Hopecolleague'));
  });
};
export const Crmhopeshare = (resolve) => {
  require.ensure(['@/components/crm/Hopeshare'], () => {
    resolve(require('@/components/crm/Hopeshare'));
  });
};
export const Crmhopestat = (resolve) => {
  require.ensure(['@/components/crm/Hopestat'], () => {
    resolve(require('@/components/crm/Hopestat'));
  });
};

// CRM部分
export const Client = (resolve) => {
  require.ensure(['@/components/client/Index'], () => {
    resolve(require('@/components/client/Index'));
  });
};
export const Clientmain = (resolve) => {
  require.ensure(['@/components/client/Main'], () => {
    resolve(require('@/components/client/Main'));
  });
};
export const Clientvfpmenu = (resolve) => {
  require.ensure(['@/components/client/Left'], () => {
    resolve(require('@/components/client/Left'));
  });
};
export const Clientsign = (resolve) => {
  require.ensure(['@/components/client/Sign'], () => {
    resolve(require('@/components/client/Sign'));
  });
};
export const Clientsigncolleague = (resolve) => {
  require.ensure(['@/components/client/Signcolleague'], () => {
    resolve(require('@/components/client/Signcolleague'));
  });
};
export const Clientsignshare = (resolve) => {
  require.ensure(['@/components/client/Signshare'], () => {
    resolve(require('@/components/client/Signshare'));
  });
};
export const Clientsignstat = (resolve) => {
  require.ensure(['@/components/client/Signstat'], () => {
    resolve(require('@/components/client/Signstat'));
  });
};
export const Clientcontract = (resolve) => {
  require.ensure(['@/components/client/Contract'], () => {
    resolve(require('@/components/client/Contract'));
  });
};


// 签到部分
export const Visit = (resolve) => {
  require.ensure(['@/components/visit/Index'], () => {
    resolve(require('@/components/visit/Index'));
  });
};
export const Visitmain = (resolve) => {
  require.ensure(['@/components/visit/Main'], () => {
    resolve(require('@/components/visit/Main'));
  });
};
export const Visitvfpmenu = (resolve) => {
  require.ensure(['@/components/visit/Left'], () => {
    resolve(require('@/components/visit/Left'));
  });
};
export const Visitrecord = (resolve) => {
  require.ensure(['@/components/visit/Record'], () => {
    resolve(require('@/components/visit/Record'));
  });
};
export const Visitstat = (resolve) => {
  require.ensure(['@/components/visit/Stat'], () => {
    resolve(require('@/components/visit/Stat'));
  });
};
export const Visitunit = (resolve) => {
  require.ensure(['@/components/visit/Unit'], () => {
    resolve(require('@/components/visit/Unit'));
  });
};


// 签到部分
export const Recruitment = (resolve) => {
  require.ensure(['@/components/recruitment/Index'], () => {
    resolve(require('@/components/recruitment/Index'));
  });
};
export const Recruitmentmain = (resolve) => {
  require.ensure(['@/components/recruitment/Main'], () => {
    resolve(require('@/components/recruitment/Main'));
  });
};
export const Recruitmentvfpmenu = (resolve) => {
  require.ensure(['@/components/recruitment/Left'], () => {
    resolve(require('@/components/recruitment/Left'));
  });
};
export const Recruitmenteesume = (resolve) => {
  require.ensure(['@/components/recruitment/Resume'], () => {
    resolve(require('@/components/recruitment/Resume'));
  });
};
export const Recruitmentinterview = (resolve) => {
  require.ensure(['@/components/recruitment/Interview'], () => {
    resolve(require('@/components/recruitment/Interview'));
  });
};


// 我的模块
export const User = (resolve) => {
  require.ensure(['@/components/user/Index'], () => {
    resolve(require('@/components/user/Index'));
  });
};
export const Usermain = (resolve) => {
  require.ensure(['@/components/user/Main'], () => {
    resolve(require('@/components/user/Main'));
  });
};
export const Uservfpmenu = (resolve) => {
  require.ensure(['@/components/user/Left'], () => {
    resolve(require('@/components/user/Left'));
  });
};
export const Userlogs = (resolve) => {
  require.ensure(['@/components/user/Logs'], () => {
    resolve(require('@/components/user/Logs'));
  });
};


// 我的模块
export const Setting = (resolve) => {
  require.ensure(['@/components/setting/Index'], () => {
    resolve(require('@/components/setting/Index'));
  });
};
export const Settingvfpmenu = (resolve) => {
  require.ensure(['@/components/setting/Left'], () => {
    resolve(require('@/components/setting/Left'));
  });
};
export const Settingaccount = (resolve) => {
  require.ensure(['@/components/setting/Account'], () => {
    resolve(require('@/components/setting/Account'));
  });
};
export const Settingrole = (resolve) => {
  require.ensure(['@/components/setting/Role'], () => {
    resolve(require('@/components/setting/Role'));
  });
};
export const Settingstatic = (resolve) => {
  require.ensure(['@/components/setting/Static'], () => {
    resolve(require('@/components/setting/Static'));
  });
};
export const Settinglogs = (resolve) => {
  require.ensure(['@/components/setting/Logs'], () => {
    resolve(require('@/components/setting/Logs'));
  });
};
export const Settingclient = (resolve) => {
  require.ensure(['@/components/setting/Client'], () => {
    resolve(require('@/components/setting/Client'));
  });
};
export const Settingcrm = (resolve) => {
  require.ensure(['@/components/setting/Crm'], () => {
    resolve(require('@/components/setting/Crm'));
  });
};
export const Settinglink = (resolve) => {
  require.ensure(['@/components/setting/Link'], () => {
    resolve(require('@/components/setting/Link'));
  });
};
export const Settingrecruitment = (resolve) => {
  require.ensure(['@/components/setting/Recruitment'], () => {
    resolve(require('@/components/setting/Recruitment'));
  });
};
export const Settingvisit = (resolve) => {
  require.ensure(['@/components/setting/Visit'], () => {
    resolve(require('@/components/setting/Visit'));
  });
};
export const Settingfiles = (resolve) => {
  require.ensure(['@/components/setting/Files'], () => {
    resolve(require('@/components/setting/Files'));
  });
};
export const Settingtimedtask = (resolve) => {
  require.ensure(['@/components/setting/Timedtask'], () => {
    resolve(require('@/components/setting/Timedtask'));
  });
};
export const Settingheadimgs = (resolve) => {
  require.ensure(['@/components/setting/Headimgs'], () => {
    resolve(require('@/components/setting/Headimgs'));
  });
};


export const Crmrecycle = (resolve) => {
  require.ensure(['@/components/crm/Recycle'], () => {
    resolve(require('@/components/crm/Recycle'));
  });
};
export const Crmblacklist = (resolve) => {
  require.ensure(['@/components/crm/Blacklist'], () => {
    resolve(require('@/components/crm/Blacklist'));
  });
};
export const Crmlecture = (resolve) => {
  require.ensure(['@/components/lecture/Lecture'], () => {
    resolve(require('@/components/lecture/Lecture'));
  });
};
export const Crmfilter = (resolve) => {
  require.ensure(['@/components/crm/Filter'], () => {
    resolve(require('@/components/crm/Filter'));
  });
};


// 仓库
// CRM部分
export const Warehouse = (resolve) => {
  require.ensure(['@/components/warehouse/Index'], () => {
    resolve(require('@/components/warehouse/Index'));
  });
};
export const Warehousemain = (resolve) => {
  require.ensure(['@/components/warehouse/Main'], () => {
    resolve(require('@/components/warehouse/Main'));
  });
};
export const Warehousevfpmenu = (resolve) => {
  require.ensure(['@/components/warehouse/Left'], () => {
    resolve(require('@/components/warehouse/Left'));
  });
};
export const Warehousedict = (resolve) => {
  require.ensure(['@/components/setting/Dict'], () => {
    resolve(require('@/components/setting/Dict'));
  });
};
export const Warehousepinpai = (resolve) => {
  require.ensure(['@/components/warehouse/Pinpai'], () => {
    resolve(require('@/components/warehouse/Pinpai'));
  });
};
export const Marktingpresented = (resolve) => {
  require.ensure(['@/components/markting/Presented'], () => {
    resolve(require('@/components/markting/Presented'));
  });
};
export const Warehousegoods = (resolve) => {
  require.ensure(['@/components/warehouse/Goods'], () => {
    resolve(require('@/components/warehouse/Goods'));
  });
};
export const Marktinggroup = (resolve) => {
  require.ensure(['@/components/markting/Group'], () => {
    resolve(require('@/components/markting/Group'));
  });
};
export const Marktingcode = (resolve) => {
  require.ensure(['@/components/markting/Code'], () => {
    resolve(require('@/components/markting/Code'));
  });
};
export const Marktingcashback = (resolve) => {
  require.ensure(['@/components/markting/Cashback'], () => {
    resolve(require('@/components/markting/Cashback'));
  });
};
export const Marktingcombination = (resolve) => {
  require.ensure(['@/components/markting/Combination'], () => {
    resolve(require('@/components/markting/Combination'));
  });
};
export const Marktingarticle = (resolve) => {
  require.ensure(['@/components/markting/Article'], () => {
    resolve(require('@/components/markting/Article'));
  });
};
export const Warehousebill = (resolve) => {
  require.ensure(['@/components/warehouse/Bill'], () => {
    resolve(require('@/components/warehouse/Bill'));
  });
};
export const Warehouserepertory = (resolve) => {
  require.ensure(['@/components/warehouse/Repertory'], () => {
    resolve(require('@/components/warehouse/Repertory'));
  });
};
export const Warehouseselllog = (resolve) => {
  require.ensure(['@/components/warehouse/Selllog'], () => {
    resolve(require('@/components/warehouse/Selllog'));
  });
};
export const Warehousegoodslog = (resolve) => {
  require.ensure(['@/components/warehouse/Goodslog'], () => {
    resolve(require('@/components/warehouse/Goodslog'));
  });
};
export const Warehouseaccountslog = (resolve) => {
  require.ensure(['@/components/warehouse/Accountslog'], () => {
    resolve(require('@/components/warehouse/Accountslog'));
  });
};


// 经销商部分
export const Dealer = (resolve) => {
  require.ensure(['@/components/dealer/Index'], () => {
    resolve(require('@/components/dealer/Index'));
  });
};
export const Dealermain = (resolve) => {
  require.ensure(['@/components/dealer/Main'], () => {
    resolve(require('@/components/dealer/Main'));
  });
};
export const Dealervfpmenu = (resolve) => {
  require.ensure(['@/components/dealer/Left'], () => {
    resolve(require('@/components/dealer/Left'));
  });
};
export const Dealeruser = (resolve) => {
  require.ensure(['@/components/dealer/User'], () => {
    resolve(require('@/components/dealer/User'));
  });
};
export const Dealerarticle = (resolve) => {
  require.ensure(['@/components/dealer/Article'], () => {
    resolve(require('@/components/dealer/Article'));
  });
};
export const Dealerimpower = (resolve) => {
  require.ensure(['@/components/dealer/Impower'], () => {
    resolve(require('@/components/dealer/Impower'));
  });
};
export const Dealerdiscount = (resolve) => {
  require.ensure(['@/components/dealer/Discount'], () => {
    resolve(require('@/components/dealer/Discount'));
  });
};
export const Dealerprice = (resolve) => {
  require.ensure(['@/components/dealer/Price'], () => {
    resolve(require('@/components/dealer/Price'));
  });
};
export const Dealerorder = (resolve) => {
  require.ensure(['@/components/dealer/Order'], () => {
    resolve(require('@/components/dealer/Order'));
  });
};
export const Dealersend = (resolve) => {
  require.ensure(['@/components/dealer/Send'], () => {
    resolve(require('@/components/dealer/Send'));
  });
};
export const Dealeraccount = (resolve) => {
  require.ensure(['@/components/dealer/Account'], () => {
    resolve(require('@/components/dealer/Account'));
  });
};
export const Dealerinvoice = (resolve) => {
  require.ensure(['@/components/dealer/Invoice'], () => {
    resolve(require('@/components/dealer/Invoice'));
  });
};


// 数据统计部分
export const Statistics = (resolve) => {
  require.ensure(['@/components/statistics/Index'], () => {
    resolve(require('@/components/statistics/Index'));
  });
};
export const Statisticsmain = (resolve) => {
  require.ensure(['@/components/statistics/Main'], () => {
    resolve(require('@/components/statistics/Main'));
  });
};
export const Statisticsdefault = (resolve) => {
  require.ensure(['@/components/statistics/Default'], () => {
    resolve(require('@/components/statistics/Default'));
  });
};
export const Statisticsvfpmenu = (resolve) => {
  require.ensure(['@/components/statistics/Left'], () => {
    resolve(require('@/components/statistics/Left'));
  });
};
export const Statisticsdealer = (resolve) => {
  require.ensure(['@/components/statistics/Dealer'], () => {
    resolve(require('@/components/statistics/Dealer'));
  });
};
export const Statisticsmall = (resolve) => {
  require.ensure(['@/components/statistics/Mall'], () => {
    resolve(require('@/components/statistics/Mall'));
  });
};
export const Statisticsbuyerstats = (resolve) => {
  require.ensure(['@/components/statistics/Buyerstats'], () => {
    resolve(require('@/components/statistics/Buyerstats'));
  });
};
export const Statisticsbuyerstatshome = (resolve) => {
  require.ensure(['@/components/statistics/Buyerstatshome'], () => {
    resolve(require('@/components/statistics/Buyerstatshome'));
  });
};


export const Statisticsselltongji = (resolve) => {
  require.ensure(['@/components/statistics/Selltongji'], () => {
    resolve(require('@/components/statistics/Selltongji'));
  });
};
export const Statisticssellmingxi = (resolve) => {
  require.ensure(['@/components/statistics/Sellmingxi'], () => {
    resolve(require('@/components/statistics/Sellmingxi'));
  });
};
export const Statisticsselldaifa = (resolve) => {
  require.ensure(['@/components/statistics/Selldaifa'], () => {
    resolve(require('@/components/statistics/Selldaifa'));
  });
};
export const Statisticssellzhangqi = (resolve) => {
  require.ensure(['@/components/statistics/Sellzhangqi'], () => {
    resolve(require('@/components/statistics/Sellzhangqi'));
  });
};

export const Statisticsinvoicedaishen = (resolve) => {
  require.ensure(['@/components/statistics/Invoicedaishen'], () => {
    resolve(require('@/components/statistics/Invoicedaishen'));
  });
};


export const Warehousesupplier = (resolve) => {
  require.ensure(['@/components/warehouse/Supplier'], () => {
    resolve(require('@/components/warehouse/Supplier'));
  });
};
export const Warehouseclearaccount = (resolve) => {
  require.ensure(['@/components/warehouse/Clearaccount'], () => {
    resolve(require('@/components/warehouse/Clearaccount'));
  });
};
export const Warehousesearchcode = (resolve) => {
  require.ensure(['@/components/warehouse/Searchcode'], () => {
    resolve(require('@/components/warehouse/Searchcode'));
  });
};


// 商城部分
export const Mall = (resolve) => {
  require.ensure(['@/components/mall/Index'], () => {
    resolve(require('@/components/mall/Index'));
  });
};
export const Mallmain = (resolve) => {
  require.ensure(['@/components/mall/Main'], () => {
    resolve(require('@/components/mall/Main'));
  });
};
export const Mallvfpmenu = (resolve) => {
  require.ensure(['@/components/mall/Left'], () => {
    resolve(require('@/components/mall/Left'));
  });
};
export const MalMarktingdiscounts = (resolve) => {
  require.ensure(['@/components/markting/Discounts'], () => {
    resolve(require('@/components/markting/Discounts'));
  });
};
export const Mallnav = (resolve) => {
  require.ensure(['@/components/mall/Nav'], () => {
    resolve(require('@/components/mall/Nav'));
  });
};
export const Mallad = (resolve) => {
  require.ensure(['@/components/mall/Ad'], () => {
    resolve(require('@/components/mall/Ad'));
  });
};
export const Mallcatalog = (resolve) => {
  require.ensure(['@/components/mall/Catalog'], () => {
    resolve(require('@/components/mall/Catalog'));
  });
};
export const Mallsend = (resolve) => {
  require.ensure(['@/components/mall/Send'], () => {
    resolve(require('@/components/mall/Send'));
  });
};
export const Mallorder = (resolve) => {
  require.ensure(['@/components/mall/Order'], () => {
    resolve(require('@/components/mall/Order'));
  });
};
export const Malluser = (resolve) => {
  require.ensure(['@/components/mall/User'], () => {
    resolve(require('@/components/mall/User'));
  });
};
export const Mallaccount = (resolve) => {
  require.ensure(['@/components/mall/Account'], () => {
    resolve(require('@/components/mall/Account'));
  });
};
export const Mallinvoice = (resolve) => {
  require.ensure(['@/components/mall/Invoice'], () => {
    resolve(require('@/components/mall/Invoice'));
  });
};
export const Mallarticle = (resolve) => {
  require.ensure(['@/components/mall/Article'], () => {
    resolve(require('@/components/mall/Article'));
  });
};

// 营销邮件
export const Markting = (resolve) => {
  require.ensure(['@/components/markting/Index'], () => {
    resolve(require('@/components/markting/Index'));
  });
};
export const Marktingmain = (resolve) => {
  require.ensure(['@/components/markting/Main'], () => {
    resolve(require('@/components/markting/Main'));
  });
};
export const Marktingvfpmenu = (resolve) => {
  require.ensure(['@/components/markting/Left'], () => {
    resolve(require('@/components/markting/Left'));
  });
};
export const Marktingemail = (resolve) => {
  require.ensure(['@/components/markting/Email'], () => {
    resolve(require('@/components/markting/Email'));
  });
};
export const Marktingwebemail = (resolve) => {
  require.ensure(['@/components/markting/Webemail'], () => {
    resolve(require('@/components/markting/Webemail'));
  });
};



// WEBPACK FOOTER //
// ./src/router/imports.js